import { combineReducers } from 'redux';

import {
  LOAD_TAG_LIST,
  SET_TAG_LIST_LOADING_STATUS,
  SET_TAG_ACTION_LOADING_STATUS,
  LOGOUT_USER
} from '../constants/action-types';

const listInitialState = {
  data: [],
  loaded: false,
  isLoading: false
};

function list(state = listInitialState, action) {
  switch (action.type) {

    case LOAD_TAG_LIST:
      return {
        ...state,
        data: action.data,
        loaded: true,
      };

    case SET_TAG_LIST_LOADING_STATUS:
      return {
        ...state,
        isLoading: action.isLoading
      };

    case LOGOUT_USER:
      return listInitialState;

    default:
      return state;
  }
}

const actionInitialState = {
  isLoading: false
};

function actions(state = actionInitialState, action) {
  switch (action.type) {

    case SET_TAG_ACTION_LOADING_STATUS:
      return {
        ...state,
        isLoading: action.isLoading
      };

    case LOGOUT_USER:
      return actionInitialState;

    default:
      return state;
  }
}

export default combineReducers({
  list,
  actions
});

